// React and Router imports
import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"

// Firebase imports
import { auth, loginWithEmailAndPassword } from "../../firebase.js"
import { useAuthState } from "react-firebase-hooks/auth"
import { useContextMenu } from "../shared/ContextMenu";
import { useQuickLinks } from "../../contexts/QuickLinksContext";

// Styles
import "../../css/Auth.css"

function Login() {
        const { enhancedRightClickEnabled } = useQuickLinks();

        const [email, setEmail] = useState("")
        const [password, setPassword] = useState("")
        const [user, loading, error] = useAuthState(auth)
        const [isSubmitting, setIsSubmitting] = useState(false)
        const navigate = useNavigate();

        const contextMenuOptions = [
                {
                        label: "Home",
                        url: "/",
                        onClick: () => navigate("/"),
                },
                {
                        label: "Register",
                        url: "/register",
                        onClick: () => navigate("/register")
                },
                {
                        label: "Forgot Password",
                        url: "/reset",
                        onClick: () => navigate("/reset")
                }
        ];
        const { showContextMenu, ContextMenuComponent } = useContextMenu(contextMenuOptions);

        useEffect(() => {
                if (loading) {
                        return
                }
                if (user) {
                        navigate("/");
                }
        }, [user, loading])

        const handleSubmit = async (e) => {
                e.preventDefault();
                setIsSubmitting(true);
                try {
                        await loginWithEmailAndPassword(email, password);
                } finally {
                        setIsSubmitting(false);
                }
        };

        return (
                <div 
                        className="container-fluid"
                        style={{
                                padding: "0",
                                minHeight: "100vh",
                                backgroundColor: "#6b9ce7"
                        }}
                        onContextMenu={enhancedRightClickEnabled ? (e) => {
                                e.preventDefault();
                                showContextMenu(e.clientX, e.clientY);
                        } : undefined}
                >

                        <div className="notification"></div>

                        <div className="row" style={{ minHeight: "100vh" }}>

                                <div className="col-12 d-flex justify-content-center align-items-center">

                                        <div className="Auth__box">

                                        <h1 className="Auth__text-center">Login</h1>

                                                <form onSubmit={handleSubmit}>
                                                        <div className="Auth__input-container">
                                                                <input
                                                                        type="text"
                                                                        value={email}
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                        required
                                                                />
                                                                <label>E-mail Address</label>
                                                        </div>
                                                        <div className="Auth__input-container">
                                                                <input
                                                                        type="password"
                                                                        value={password}
                                                                        onChange={(e) => setPassword(e.target.value)}
                                                                        required
                                                                />
                                                                <label>Password</label>
                                                        </div>
                                                        <button
                                                                type="submit"
                                                                className="Auth__btn"
                                                                disabled={isSubmitting}
                                                                style={{ position: "relative" }}
                                                        >
                                                                {isSubmitting ? (
                                                                        <span className="spinner"></span>
                                                                ) : (
                                                                        "Login"
                                                                )}
                                                        </button>
                                                </form>
                                                
                                                <div style={{ paddingTop: "30px" }}>
                                                        <Link to="/reset">Forgot Password</Link>
                                                </div>
                                                <div style={{ color: "white" }}>
                                                        Don't have an account? <Link to="/register">Register</Link> now.
                                                </div>

                                        </div>

                                </div>

                        </div>

                        {enhancedRightClickEnabled && ContextMenuComponent}
                </div>
        )

}

export default Login